import {
  useParseContentForQuestionCreation,
  type UseParseContentForItemSetQuestionInput,
} from '../use-parse-content-for-question-creation';

export function useParseContentForItemSetQuestionCreation(
  params: UseParseContentForItemSetQuestionInput,
) {
  const { parseContentForDisplay } = useParseContentForQuestionCreation(params);

  return { parseItemSetQuestionContent: parseContentForDisplay };
}
